import styled from '@emotion/styled/macro';

export const CardCTABlock = styled.div`
  display: flex;
  max-width: 400px;
  margin: 0 auto;
  padding: 20px 0;
  flex-direction: column;
  gap: 10px;
  text-align: center;
`;

export const CardCTATitle = styled.h2`
  font-family: 'FuturaStd';
  line-height: 26px;
  font-size: ${20 / 16}rem;
  font-weight: 700;
  color: var(--brand-black);
`;

export const CardCTAText = styled.p`
  line-height: 20px;
  font-size: ${14 / 16}rem;
  color: var(--brand-black);
`;

export const CardContainer = styled.div`
  --photo-width: 58px;
  display: grid;
  grid-template-columns: var(--photo-width) minmax(0, 1fr) 24px;
  column-gap: 20px;
  align-items: center;
  @media (min-width: 500px) {
    --photo-width: 86px;
  }
  button[data-variant='icon'] {
    grid-row: 1;
    grid-column: 3;
    align-self: flex-start;
  }
`;

export const ProfilePhoto = styled.img`
  width: var(--photo-width);
  height: var(--photo-width);
  border-radius: 50%;
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: ${14 / 16}rem;
  @media (min-width: 800px) {
    font-size: 1rem;
  }
  a {
    color: var(--brand-black);
    text-decoration: underline;
  }
`;

export const CardDetailsHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const CardTitle = styled.h1`
  font-family: 'FuturaStd';
  font-weight: 700;
  font-size: 1rem;
  color: var(--brand-black);
  @media (min-width: 800px) {
    font-size: ${24 / 16}rem;
  }
`;

export const CardActions = styled.div`
  display: flex;
  gap: 10px;
  grid-column: 2;
  margin-top: 4px;
  @media (min-width: 800px) {
    margin-top: 0;
  }
  button {
    margin: 0;
  }
  button[data-variant='primary'] {
    background: var(--brand-black);
  }
`;
